import React from 'react';
import './ContactInfo.css';

const ContactInfo = () => {
  return (
    <div className="contact-section">
      <div className="contact-card">
        {/* Left Section */}
        <div className="contact-left">
          <h2>Kontakt und Wegbeschreibung</h2>
          <hr className="contact-divider" />

          <div className="contact-block">
            <div>
              <p style={{ fontWeight: 'bold', marginBottom: '10px', color: '#e80000' }}>Inhaber: Mahadevi Motty</p>
              <h4>Telefon</h4>
              <p>07552 3822 766</p>
              <p>0172 2389 459</p>
            </div>
            <div>
              <h4>Adresse</h4>
              <p>Hauptstraße 24</p>
              <p>88630 Pfullendorf</p>
            </div>
          </div>

          <div className="contact-block">
            <div>
              <h4>E-Mail</h4>
              <p>info@papadam-pfullendorf.de</p>
            </div>
          </div>

          <a href="#" className="feedback-link">
            Sie haben Anregungen oder Feedback?
          </a>
        </div>

        {/* Right Section */}
        <div className="contact-right">
         <img
  src="/images/p13.jpg"
  alt="Restaurant Table"
/>

        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
